import Footer from './dist';
export default Footer;
